import React from 'react';
import { Factory, Zap, Car, ChefHat, Building2, Truck } from 'lucide-react';
import './ServicesSection.css';

const ServicesSection = () => {
  const services = [
    {
      icon: <Factory size={48} />,
      title: 'Maschinen im Betrieb',
      description: 'Schonende Reinigung von Produktionsmaschinen während des laufenden Betriebs ohne Demontage.',
      image: 'https://images.unsplash.com/photo-1600715502630-c9300abe78a3?w=800&q=80'
    },
    {
      icon: <Zap size={48} />,
      title: 'Stromkästen & Platinen',
      description: 'Sichere und rückstandsfreie Reinigung elektrischer Komponenten und Steuerungssysteme.',
      image: 'https://images.unsplash.com/photo-1544724569-5f546fd6f2b5?w=800&q=80'
    },
    {
      icon: <Car size={48} />,
      title: 'Auto, Motorrad & Boot',
      description: 'Mit unserer Trockeneis-Reinigung entfernen wir Schmutz, Gerüche und Ablagerungen zuverlässig.',
      image: 'https://images.unsplash.com/photo-1641935289691-232d6372ec4b?w=800&q=80'
    },
    {
      icon: <ChefHat size={48} />,
      title: 'Gastronomie',
      description: 'Hygienische Tiefenreinigung von gewerblichen Küchenanlagen und Lebensmittelmaschinen.',
      image: 'https://images.unsplash.com/photo-1589109807644-924edf14ee09?w=800&q=80'
    },
    {
      icon: <Building2 size={48} />,
      title: 'Steinmauern & Außenflächen',
      description: 'Wir reinigen Steinmauern, Fassaden und Außenflächen fachgerecht und materialschonend.',
      image: 'https://images.unsplash.com/photo-1496236436299-cde70e3587cf?w=800&q=80'
    },
    {
      icon: <Truck size={48} />,
      title: 'Baumaschinen & Nutzfahrzeuge',
      description: 'Hartnäckiger Schmutz wird effektiv entfernt – für saubere und einsatzbereite Maschinen.',
      image: 'https://images.unsplash.com/photo-1534097575056-ddba81f714c8?w=800&q=80'
    }
  ];

  return (
    <section id="services" className="services-section">
      <div className="services-container">
        <div className="services-header">
          <h2 className="services-title">Unsere Dienstleistungen</h2>
          <p className="services-description">
            Vielseitige Reinigungslösungen für verschiedenste Anwendungsbereiche
          </p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-image-container">
                <img 
                  src={service.image} 
                  alt={service.title}
                  className="service-image"
                />
                <div className="service-overlay">
                  <div className="service-icon">{service.icon}</div>
                </div>
              </div>
              <div className="service-content">
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;